<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <template #activator="{ on, attrs }">
      <v-btn
        color="primary"
        dark
        v-bind="attrs"
        v-on="on"
      >
        <slot />
      </v-btn>
    </template>
    <form @submit.prevent="save">
      <v-card>
        <v-toolbar flat>
          <v-toolbar-title>Leave Team</v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="cancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          Are you sure you would like to leave this team?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text @click="cancel">
            Cancel
          </v-btn>
          <v-btn :loading="form.processing" color="primary" type="submit">
            Leave
          </v-btn>
        </v-card-actions>
      </v-card>
    </form>
  </v-dialog>
</template>

<script>
export default {
   components: {
      //
   },

   props: {
      team: {
         type: Object,
         required: true
      },
      user: {
         type: Object,
         required: true
      }
   },

   data () {
      return {
         dialog: false,

         form: this.$inertia.form({
            role: null,
         }),
      }
   },

   methods: {
      cancel () {
         this.dialog = false
      },

      save () {
         this.form.put(this.route('team-members.update', [this.team, this.managingRoleFor]), {
            preserveScroll: true,
         }).then(() => {
            this.dialog = false
         })
      },
   }
}
</script>
